// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import "flowbite/dist/flowbite.turbo.js";

document.addEventListener("turbo:load", () => {
  if (typeof gtag === "function") {
    gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: location.href
    });
  }
});